import React from "react";
import Insights from "../Components/Insights/Index";
import DataInjection from "../Components/Data_Injection/Index";
import ViewPastUploads from "../Components/ViewPast_Uploads/Index";
import AuditUniverse from "../Components/Data_Injection/Audit-Universe/Index";
import Dashboard from "../pages/Dashboard";
import EDA from "../Components/Insights/EDA";
import FraudDetection from "../Components/Insights/Fraud_Detection";
import { label, path } from "framer-motion/client";
import ProcessMining from "../Components/Insights/Process-Mining/Index";
import AnnomolyDetection from "../Components/Insights/Annomoly-Detection/Index";
import SubModulePage from "../Components/Data_Injection/Audit-Universe/SubProcessModule";
import ProcessDetailsPage from "../Components/Data_Injection/Audit-Universe/ProcessDetailsPage";
import SubSubProcessModule from "../Components/Data_Injection/Audit-Universe/SubSubProcessModule";

const routes = [
  // {
  //   path: "/",
  //   label: "Dashboard",
  //   element: <Dashboard />,
  // },
  {
    path: "/Insights",
    label: "Insights",
    children: [
      {
        path: "EDA",
        label: "EDA",
        element: <EDA />,
      },
      {
        path: "fraud-detection",
        label: "Fraud Detection",
        element: <FraudDetection />,
      },
      {
        path: "process-mining",
        label: "Process Mining",
        element: <ProcessMining />,
      },
      {
        path: "annomoly-detection",
        label: "Annomoly Detection_AI-ML",
        element: <AnnomolyDetection />,
      },
    ],
  },

  {
    path: "/data-injection",
    label: "Data Injection",
    children: [
      // {
      //   index: true,
      //   label: "Data Injection",
      //   element: <DataInjection />,
      // },
      {
        path: "audit-universe",
        label: "Audit Universe",
        element: <AuditUniverse />,
      },
      {
        path:"SubModulePage",
        label: "Sub-Module Page",
        element:<SubModulePage/>,
        hidden: true,
      },
      {
        path:'SubSubProcessModule',
        label: "Sub-Sub-Process Module",
        element:<SubSubProcessModule/>,
        hidden: true,
      },
      {
        path: "process-details",
        label: "Process Details",
        element: <ProcessDetailsPage/>,
        hidden: true,
      }
    ],
  },
  {
    path: "/view-past-uploads",
    label: "View Past Uploads",
    element: <ViewPastUploads />,
  },
];

export default routes;
